import { defineMeta } from '@/registry/types';

export const dashboardLayoutMeta = defineMeta({
  name: 'DashboardLayout',
  level: 'template',
  category: 'layout',
  classification: 'custom',
  description: 'Application shell with AppBar, collapsible LeftNavigation and a scrollable content region.',
  baseLibrary: 'custom',
  a2uiEquivalent: 'AppShell',
  importPath: '@/templates/DashboardLayout',
  requiredProps: ['children', 'navItems'],
  optionalProps: [
    'selectedNavId',
    'onNavSelect',
    'brand',
    'toolbar',
    'collapsed',
    'onToggleNav',
    'navLinkComponent',
  ],
  supportedStates: ['default', 'collapsed-nav'],
  designTokens: ['colors', 'spacing'],
  accessibility: ['Provides banner, navigation and main landmarks.'],
  usageExamples: ['<DashboardLayout navItems={items} selectedNavId={id} onNavSelect={set}>...</DashboardLayout>'],
  rules: [
    'Give navItems an href and pass navLinkComponent (next/link, react-router Link) when the nav moves between routes, so the rail renders links rather than buttons.',
  ],
  antiPatterns: ['Do not nest DashboardLayouts.'],
  llmSafe: true,
  whenToUse: ['Top-level app pages requiring the standard shell'],
  whenNotToUse: ['Auth/marketing pages without navigation'],
});

export default dashboardLayoutMeta;
